class RankingScopesFilter {
    filter(
        rankingScopesAndParameters,
        { context, sessionId, teamId, opponentTeamId, tagId, handedness, opponentId, opponentHandedness, pitchType },
        havingParameters
    ) {
        if (!(rankingScopesAndParameters instanceof Array)) {
            throw new TypeError('rankingScopesAndParameters must be an array');
        }
        if (typeof(havingParameters) !== 'undefined' && !(havingParameters instanceof Array)) {
            throw new TypeError('havingParameters must be undefined or an array');
        }

        return rankingScopesAndParameters.filter(rs => {
            return (
                (!sessionId || sessionId === rs.scope.sessionId)
                && (!context || context === rs.scope.context)
                && (!tagId || tagId === rs.scope.tagId)
                && (!opponentId || opponentId === rs.scope.opponentId)
                && (!pitchType || pitchType === rs.scope.pitchType)
                && (!teamId || teamId === rs.scope.teamId)
                && (!opponentTeamId || opponentTeamId === rs.scope.opponentTeamId)
                && (!handedness || handedness === rs.scope.handedness)
                && (!opponentHandedness || opponentHandedness === rs.scope.opponentHandedness)
                && (!havingParameters || rs.scope.parameters.some(p => havingParameters.includes(p.parameter)))
            );
        });
    }
}

export default RankingScopesFilter;